import { type ReactNode } from 'react';
import { graphql, type PreloadedQuery, usePreloadedQuery } from 'react-relay';

import type { UserPermContextType } from '../utils/user-perm-context';
import { UserPermContext } from '../utils/user-perm-context';

import type { userPermContextProviderQuery } from './__generated__/userPermContextProviderQuery.graphql';

export const UserPermContextProvider = ({
	children,
	queryRef,
}: {
	children: ReactNode;
	queryRef: PreloadedQuery<userPermContextProviderQuery>;
}) => {
	const data = usePreloadedQuery<userPermContextProviderQuery>(
		graphql`
			query userPermContextProviderQuery($cloudID: ID!, $atlassianAccountId: ID!) {
				devai_rovoDevAgentsUser(cloudId: $cloudID, atlassianAccountId: $atlassianAccountId)
					@optIn(to: "DevAiUsers") {
					hasProductAccess
					isAdmin
				}
			}
		`,
		queryRef,
	);

	const userPerms: UserPermContextType = {
		rovoDevAgentsUser: {
			hasProductAccess: data.devai_rovoDevAgentsUser?.hasProductAccess || false,
			isAdmin: data.devai_rovoDevAgentsUser?.isAdmin || false,
		},
	};

	return <UserPermContext.Provider value={userPerms}>{children}</UserPermContext.Provider>;
};
